import { render, staticRenderFns } from "./RiskMatrixReportConfigurations.vue?vue&type=template&id=6a522b04&scoped=true&"
import script from "./RiskMatrixReportConfigurations.vue?vue&type=script&lang=js&"
export * from "./RiskMatrixReportConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./RiskMatrixReportConfigurations.vue?vue&type=style&index=0&id=6a522b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a522b04",
  null
  
)

export default component.exports